import Dimensions from "react-native-web/dist/exports/Dimensions";
import { viewports } from '@telus-uds/system-constants';
import useSafeLayoutEffect from '../utils/useSafeLayoutEffect';

// Use Dimensions instead of useWindowDimensions because useWindowDimensions forces context
// to update on every pixel change during window resize; but we only want rerenders to occur
// when a viewport threshold has been crossed.
const lookupViewport = () => viewports.select(Dimensions.get('window').width);

/**
 * When client-side rendering, immediately set the viewport to the correct value as a layout effect so
 * if the viewport isn't the smallest, any SSR-rendered components rerender correctly before anything
 * is shown to the user. Then bind events to update the viewport if it changes.
 */
const useViewportListener = setViewport => {
  useSafeLayoutEffect(() => {
    setViewport(lookupViewport());
    const onChange = _ref => {
      let {
        window
      } = _ref;
      return setViewport(viewports.select(window.width));
    };
    const listener = Dimensions.addEventListener('change', onChange);
    return () => {
      if (typeof listener?.remove === 'function') {
        // Can't just return listener.remove because listener.emitter disappears, causing an internal error.
        // See https://github.com/facebook/react-native/issues/34508
        listener.remove();
        // From RN 0.65.0, Dimensions.removeEventListener is deprecated for `remove` on addEventListener return value
      } else if (typeof Dimensions.removeEventListener === 'function') {
        Dimensions.removeEventListener('change', onChange);
      }
    };
  }, [setViewport]);
};
export default useViewportListener;